const ADMIN_NOTICE_SEEN_SAMPLE_ID_KEY = "admin_notice_seen_sample_id";

/**
 * 管理者通知を表示済みのサンプル ID を取得する。
 * 仕様: 直近1件のみ保持する。
 */
export const readSeenAdminNoticeSampleId = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.sessionStorage.getItem(ADMIN_NOTICE_SEEN_SAMPLE_ID_KEY);
  } catch (_error) {
    return null;
  }
};

/**
 * 管理者通知を表示済みのサンプル ID を保存する。
 * 仕様: 直近1件のみ保持する。
 */
export const writeSeenAdminNoticeSampleId = (id: string) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.setItem(ADMIN_NOTICE_SEEN_SAMPLE_ID_KEY, id);
  } catch (_error) {
    // sessionStorage アクセスエラーを無視（通知表示に影響しない）
  }
};
